package one.healthium.insights.ui.shopping_list.models

import loco.Res
import loco.SHOPPING_LIST_CATEGORY_ALL_LABEL
import one.healthium.loco.LString
import one.healthium.loco.asLString
import androidx.compose.runtime.Immutable

@Immutable
internal data class CategoriesUiModel(
    val categories: List<CategoryUiModel>,
    val currentCategoryId: String,
)

@Immutable
internal data class CategoryUiModel(
    val id: String,
    val name: LString,
) {
    companion object {
        val ALL = CategoryUiModel(
            id = "ALL",
            name = Res.string.SHOPPING_LIST_CATEGORY_ALL_LABEL.asLString(),
        )
    }
}
